import { Link } from 'react-router-dom';

import { medicareEnrollLogoWhiteBackroundWAlt } from 'utilities/altText';

import image from './image.svg';

import styles from './styles.module.scss';

const Logo = ({ className = '' }) => (
    <Link
        className={`${styles.logo} ${className}`}
        data-click-type="link"
        to="/"
    >
        <img
            alt={medicareEnrollLogoWhiteBackroundWAlt}
            className={`${styles.logo} ${className}`}
            src={image}
        />
    </Link>
);

export default Logo;
